import { QUERY_KEY } from "./queryKeys";

/** Ethereum address casing must not create separate identity caches. */
export const userProfileKey = (address?: string): readonly string[] => [
  QUERY_KEY.userInfo,
  QUERY_KEY.detail,
  address?.toLowerCase() ?? "",
];
